import {useEffect, useState, FunctionComponent} from 'react';
import {Facet as HeadlessFacet, DateFacet, FacetValue} from '@coveo/headless';
import '../scss/Facet-Accordion.scss';
import React from 'react';
import {useSelector} from "react-redux";
 
interface FacetProps {
  controller: HeadlessFacet;
  title?: any;
  facetDeSelect?: any;
  pillProSelected?: any;
  pillConsumerSelected?: any;
  pillBusinessSelected?: any;
  facetPreselect?: string;
}

export const CheckboxRecommended: FunctionComponent<FacetProps> = (props) => {
  const {controller} = props;
  const [state, setState] = useState(controller.state);
  const [show, setShow] = useState(false);
  const isShowRecommendedForModel = useSelector((state: any) => state.searchBoxReducer.isShowRecommendedForModel);
  let isMobileView = window.innerWidth < 768;
  useEffect(() => controller.subscribe(() =>{
     // ignore value number of resuslt less than 0 
     if(controller.state.values.length > 0){
      const ingoreNumberOfResultZero = controller.state.values.filter((value : any , index: number) =>   value.numberOfResults > 0)
      setState({...controller.state, values:ingoreNumberOfResultZero })
    }else{
     setState(controller.state)
    }
  })
  , [controller, show]);

  if (!state.values.length) {
    return <div></div>;
  }

  function getShowMore() {
    return (
      <div
          className={"viewmore-btn" + (isMobileView ? " deactive" : "")}
        onClick={() => {
            setShow(true)
        }}
      >
        View More
      </div>
    );
  }

  function getShowLess() {
    return (
      <div
        className="viewless-btn"
        onClick={() => {
          setShow(false)
        }}
      >
        Less
      </div>
    );
  }
  function expandCollapseAccordion(e: any) {
    const accordion = e.target;
    const children = e.target.nextElementSibling;
    const viewmoreBtn = e.target.closest(".facet-accordion-container").querySelector(".viewmore-btn");
    const viewLessBtn = e.target.closest(".facet-accordion-container").querySelector(".viewless-btn");
    if(!accordion.classList.contains("collapsed")){
      accordion.classList.add("collapsed");
      children.classList.add("deactive");
      if(viewmoreBtn){
        viewmoreBtn.classList.add("deactive");
      }
      if(viewLessBtn){
        viewLessBtn.classList.add("deactive");
      }
    }
    else{
      accordion.classList.remove("collapsed")
      children.classList.remove("deactive");
      if(viewmoreBtn){
        viewmoreBtn.classList.remove("deactive");
      }
      if(viewLessBtn){
        viewLessBtn.classList.remove("deactive");
      }
    }
  }

  return (
      <div className="facet-type-item">
        <div className="facet-accordion-container">
          <div className="facet-accordion">
            <button
                className={"facet-type" + (isMobileView ? " collapsed":"")}
                onClick={(e) => expandCollapseAccordion(e)}
            >
              {props.title}
            </button>
            <div className={"facet-accordion-children" + (isMobileView ? " deactive":"")}>
              {state.values.map((value, index) => {
                if (value.value !== isShowRecommendedForModel) {
                  return ""
                }
                return (
                    <div className="facet-child" key={value.value}>
                      <div>
                        <input
                            type="checkbox"
                            data-model-name={value.value}
                            checked={controller.isValueSelected(value)}
                            onChange={() => {
                              controller.toggleSelect(value);
                              window.scroll(50, 0);
                            }}
                            disabled={state.isLoading}
                            id={state.facetId + index}
                        />
                        <label htmlFor={state.facetId + index} className="facet-label">
                          <div className="label">Recommended</div>
                        </label>
                      </div>
                    </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
  );
};
